import { Injectable } from '@angular/core';

@Injectable()
export class Utils {

    base64KeyStr: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    Base64Decode(input: string): string {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = this.base64KeyStr.indexOf(input.charAt(i++));
            enc2 = this.base64KeyStr.indexOf(input.charAt(i++));
            enc3 = this.base64KeyStr.indexOf(input.charAt(i++));
            enc4 = this.base64KeyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }

        }

        output = this.Base64Utf8_decode(output);

        return output;

    }

    Base64encode(input: string): string {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = this.Base64Utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
                this.base64KeyStr.charAt(enc1) + this.base64KeyStr.charAt(enc2) +
                this.base64KeyStr.charAt(enc3) + this.base64KeyStr.charAt(enc4);

        }

        return output;
    }

    Base64Utf8_decode(utftext: string): string {
        var string = "";
        var i = 0;
        var c = 0;
        var c1 = 0;
        var c2 = 0;

        while (i < utftext.length) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                var c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        }

        return string;
    }

    Base64Utf8_encode(string: string): string {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    }

    bsin(longitud?: number): string {
        longitud = (longitud == undefined) ? 20 : longitud;
        var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
        var bsin = "";
        for (var i = 0; i < longitud; i++) bsin += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
        return bsin;
    }

    checkEmail(email: string): boolean {
        return (/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i).test(email);
        // return ((/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/).test(email));
    }

    checkNifCif(nifCif: string) {
        const NIF_Letters = "TRWAGMYFPDXBNJZSQVHLCKET";
        const NIF_regExp = "^\\d{8}[a-zA-Z]{1}$";
        const CIF_regExp = "^[a-zA-Z]{1}\\d{7}[a-jA-J0-9]{1}$";

        // VALIDA EL NIF
        const checkNIF = function (nif) {
            // Comprueba la longitud. Los DNI antiguos tienen 7 digitos.
            if ((nif.length != 8) && (nif.length != 9)) return false;
            if (nif.length == 8) nif = '0' + nif; // Ponemos un 0 a la izquierda y solucionado

            // Comprueba el formato
            var regExp = new RegExp(NIF_regExp);
            if (!nif.match(regExp)) return false;

            var letter = nif.charAt(nif.length - 1);
            var dni = nif.substring(0, nif.length - 1)
            var letra = NIF_Letters.charAt(dni % 23);
            return (letra == letter.toUpperCase());
        }

        // VALIDA TARJETA DE RESIDENCIA
        const checkTR = function (tr) {
            if ((tr.length != 10) && (tr.length != 9)) return false;
            if ((tr.charAt(0).toUpperCase() != "X") && (tr.charAt(0).toUpperCase() != "Y") && (tr.charAt(0).toUpperCase() != "Z")) return false;

            var leftNum = '0';
            if (tr.charAt(0).toUpperCase() == "Y") leftNum = '1';

            if (tr.length == 9) {
                return checkNIF(leftNum + tr.substring(1, tr.length));
            } else {
                return checkNIF(tr.substring(1, tr.length));
            }
        }

        // VALIDA TARJETA DE RESIDENCIA
        const checkCIF = function (cif) {
            var v1 = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
            var tempStr = cif.toUpperCase(); // pasar a mayúsculas
            var temp = 0;
            var temp1;
            var dc;

            // Comprueba el formato
            var regExp = new RegExp(CIF_regExp);
            if (!tempStr.match(regExp)) return false;    // Valida el formato?
            if (!/^[ABCDEFGHIJKLMNPQS]/.test(tempStr)) return false;  // Es una letra de las admitidas ?

            for (let i = 2; i <= 6; i += 2) {
                temp = temp + v1[parseInt(cif.substr(i - 1, 1))];
                temp = temp + parseInt(cif.substr(i, 1));
            };
            temp = temp + v1[parseInt(cif.substr(7, 1))];
            temp = (10 - (temp % 10));
            if (temp == 10) temp = 0;
            dc = cif.toUpperCase().charAt(8);
            return (dc == temp) || (temp == 1 && dc == 'A') || (temp == 2 && dc == 'B') || (temp == 3 && dc == 'C') || (temp == 4 && dc == 'D') || (temp == 5 && dc == 'E') || (temp == 6 && dc == 'F') || (temp == 7 && dc == 'G') || (temp == 8 && dc == 'H') || (temp == 9 && dc == 'I') || (temp == 0 && dc == 'J');
        }



        if (checkCIF(nifCif)) { // Comprueba el CIF
            console.log('checkCIF');
            return true;
        } else if (checkTR(nifCif)) { // Comprueba tarjeta de residencia
            console.log('checkTR');
            return true;
        } else if (checkNIF(nifCif)) { // Comprueba el NIF
            console.log('checkNIF');
            return true;
        } else {           // Si no pasa por ninguno es false.
            console.log('error nif cif tarjeta residencia');
            return false;
        }
    }

    checkTelefono(tel: string): boolean {
        return (/^(\+34|0034|34)?[6|7|9][0-9]{8}$/i).test(tel);
    }
}


// WEBPACK FOOTER //
// ./src/app/providers/utils.ts